export const SITE_NAME = "RxNorm";
